import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { PrescriptionService } from "../../services/prescription.service";
import { PresignedUrlService } from "../../services/presigned-url.service";
import { environment } from "src/environments/environment";
import { Router } from '@angular/router';

@Component({
  selector: 'core-file-uploader',
  templateUrl: './file-uploader.component.html',
  styleUrls: ['./file-uploader.component.scss']
})
export class FileUploaderComponent implements OnInit {

  @Output() onFileUploaded = new EventEmitter<boolean>();
  @Input() accept: string;
  @Input() uploadButtonText: string | null;
  @Input() orderId: number | null;
  fileName: string = "";
  fileSize: string = "";
  file: File | null = null;
  fileSelected: boolean = false;

  constructor(
    private presignedUrlService: PresignedUrlService
  ) { }

  ngOnInit(): void {
    
  }

  openInput() {
    const fileInput = document.getElementById("fileInput");
    if (fileInput)
      fileInput.click();
  }

  onChange(event: Event) {
    const input = event.target as HTMLInputElement;

    if (!input.files?.length) {
      return;
    }

    this.fileSelected = true;

    const file: File = input.files[0];

    this.fileName = file.name;
    this.file = file;
    let _size = file.size;
    const units: string[] = ['Bytes', 'KB', 'MB', 'GB'];
    let i: number = 0;

    while (_size > 900) {
      _size /= 1024;
      i++;
    }

    this.fileSize = (Math.round(_size * 100) / 100) + ' ' + units[i];
  }

  async uploadFile() {
    if (!this.orderId && !this.file) return;

    const key = `${environment.s3.folder}/${this.orderId}/${environment.s3.fileName}`;

    const presignedUrlResponse = await this
      .presignedUrlService
      .generateUploadUrl(
        environment.s3.region,
        environment.s3.bucket,
        key);

    const response: any = await this
      .presignedUrlService
      .uploadFileToS3(presignedUrlResponse.data.url, this.file as File);

    if (response.ok)
      this.onFileUploaded.emit(true);
    else
      this.onFileUploaded.emit(false);
  }

}
